let _alertRef;
let _infoRef;
let _confirmRef;
let _unsavedRef;
let _removeRef;
let _inlineRef;
let _authenticationRef;

// Private
const error = (message) => {
    console.error("Modal thrown but modals framework was not loaded.", message);
    return false;
}

// Hooks
export const hookAlert = (alertRef) => {
    _alertRef = alertRef;
}

export const hookInfo = (infoRef) => {
    _infoRef = infoRef;
}

export const hookConfirm = (confirmRef) => {
    _confirmRef = confirmRef;
}

export const hookUnsaved = (unsavedRef) => {
    _unsavedRef = unsavedRef;
}

export const hookRemove = (removeRef) => {
    _removeRef = removeRef;
}

export const hookInline = (inlineRef) => {
    _inlineRef = inlineRef;
}

export const hookAuthentication = (authenticationRef) => {
    _authenticationRef = authenticationRef;
}

// Functions
export const alert = (message, onClose) => {
    if (!_alertRef)
        return error(message);
    
    _alertRef.open(message, onClose);
}

export const info = (title, message, onClose) => {
    if (!_infoRef)
        return error(message);
    
    _infoRef.open(title, message, onClose);
}

export const confirm = (question, yes, no) => {
    if (!_confirmRef)
        return error(question);

        _confirmRef.open(question, yes, no);
}

export const unsaved = (question, yes, no) => {
    if (!_unsavedRef)
        return error(question);

        _unsavedRef.open(question, yes, no);
}

export const remove = (title, name, id, yes, no) => {
    if (!_removeRef)
        return error(title);

        _removeRef.open(title, name, id, yes, no);
}

export const inline = (content, onClose) => {
    if (!_inlineRef)
        return error(content);

        _inlineRef.open(content, onClose);
}

export const authentication = (userId, onClose) => {
    if (!_authenticationRef)
        return error(userId);

    _authenticationRef.open(userId, onClose);
}


// WEBPACK FOOTER //
// ./src/fw/globals/Modals.js